
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function ProtectedRoute({ children, requiredRole }) {
    const { token, role, loading, authChecked } = useContext(AuthContext);

    // ждем пока проверится auth
    if (!authChecked) return null;


    if (loading) return null;

    // теперь проверяем доступ
    if (!token || (requiredRole && role !== requiredRole)) {
        return <Navigate to="/" replace />;
    }

    return children;
}